import { requestorHelperService } from '@/requestors/requestor-helper-service.js';
import { lineRequestorHelperService } from '@/requestors/line-requestor-helper-service.js';
import _ from 'lodash';

function getSlideRequest (data, title, subtitle, settings) {
    let chartSlide = { SlideType: 'line-chart', ChartRequests: [] };
    chartSlide.Title = title || 'Brand Metric Trend within Pillar';
    chartSlide.Subtitle = subtitle;

    if (data) {
        chartSlide.ChartRequests.push(buildChartRequests(data, settings));
    }

    return chartSlide;
}

function buildChartRequests (data, settings) {
    let chartRequest = lineRequestorHelperService.buildChartRequest(settings);
    if (data) {
        let seriesIndex = 0;
        settings.series.forEach(s => {
            let currentSeriesData = _.filter(data, d => d.series === s.id);
            let transformedData = _.map(currentSeriesData, d => ({ Category: d.date, YValue: d.score }));
            lineRequestorHelperService.addSeriesAndLegend(chartRequest, seriesIndex, s.name, s.colour, transformedData);
            seriesIndex++;
        });
    }
    return chartRequest;
}

class BrandMetricDetailProgressRequestor {
    generatePPTXRequest (data, title, subtitle, settings) {
        return requestorHelperService.buildPresentationRequest(getSlideRequest, 'brand_metric_progress_within_pillar.pptx', data, title, subtitle, settings);
    }

    getSlideRequest (data, title, subtitle, settings) {
        return getSlideRequest(data, title, subtitle, settings);
    }
}

export const brandMetricDetailProgressRequestor = new BrandMetricDetailProgressRequestor();
